module.exports = __webpack_public_path__ + "static/img/8301_phase_function_Paper_PointsHejduk_Prediction.8f0c9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8301_phase_function_Paper_PointsHejduk_Prediction.png
// module id = td4R
// module chunks = 0